'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = require('../../../packages/common-utilities/src/constants.js');

var _constants2 = _interopRequireDefault(_constants);

var _currency_utility = require('../../../packages/common-utilities/src/currency_utility.js');

var _currency_utility2 = _interopRequireDefault(_currency_utility);

var _disclosure = require('./disclosure.js');

var _disclosure2 = _interopRequireDefault(_disclosure);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _table_component = require('./global_components/table_component.js');

var _table_component2 = _interopRequireDefault(_table_component);

var _ramda = require('ramda');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactWaypoint = require('react-waypoint');

var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _reactIntl = require('react-intl');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _formatted_number = require('./global_components/formatted_number');

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _sanitize_utility = require('../../../packages/common-utilities/src/sanitize_utility.js');

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _collection_utility = require('common-utilities/src/collection_utility');

var _button = require('./global_components/button');

var _button2 = _interopRequireDefault(_button);

var _accessibility_utility = require('../../../packages/common-utilities/src/accessibility_utility');

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var dataIsNotNil = function dataIsNotNil(data) {
  return (0, _ramda.complement)(_ramda.isNil)(data);
};

var BreakdownTableChildCard = function (_React$Component) {
  _inherits(BreakdownTableChildCard, _React$Component);

  function BreakdownTableChildCard(props) {
    _classCallCheck(this, BreakdownTableChildCard);

    var _this = _possibleConstructorReturn(this, (BreakdownTableChildCard.__proto__ || Object.getPrototypeOf(BreakdownTableChildCard)).call(this, props));

    _this.getHeaderColSpan = function (subColumnHeader, i) {
      if (!(0, _functional_utility.isNilOrEmpty)(_this.props.subColumnHeaderSpans)) {
        return _this.props.subColumnHeaderSpans[i];
      }
      return subColumnHeader.length === 2 && i === 0 ? 3 : 1;
    };

    _this.computeDisclosureAndRenderIcon = _this.computeDisclosureAndRenderIcon.bind(_this);
    _this.renderValue = _this.renderValue.bind(_this);
    _this.getIconEl = _this.getIconEl.bind(_this);
    _this.handleDisclosureIconClick = _this.handleDisclosureIconClick.bind(_this);
    return _this;
  }

  _createClass(BreakdownTableChildCard, [{
    key: 'renderHeaderValue',
    value: function renderHeaderValue(data) {
      var displayKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "displayValue";
      var valueKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "value";
      var dataType = data.dataType;

      var displayValueFromData = data[displayKey];
      var valueFromData = data[valueKey];
      var defaultValue = "-";
      var isCurrencyDataType = dataType === "CURRENCY";

      if (isCurrencyDataType) {
        return _formatted_number2.default.prototype.numberFormatter(_currency_utility2.default.convertToCurrencyWithScaleSuffixAnd2DecimalsWithNoRounding(valueFromData, "USD"), this.props.numberFormat);
      } else if (dataIsNotNil(displayValueFromData) && displayValueFromData !== defaultValue) {
        var dataPointSuffix = _constants2.default.getDataPointSuffix()[dataType];
        return _formatted_number2.default.prototype.numberFormatter(displayValueFromData + _string_utility2.default.getLocalizedString(this.props.intl, dataPointSuffix.value, dataPointSuffix.translationKey, {}), this.props.numberFormat);
      }

      return "";
    }
  }, {
    key: 'renderValue',
    value: function renderValue(data) {
      var displayKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "displayValue";
      var valueKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "value";
      var dataType = data.dataType;

      var displayValueFromData = data[displayKey];
      var valueFromData = data[valueKey];
      var defaultValue = "-";
      var isCurrencyDataType = dataType === "CURRENCY";

      if (dataType === "CURRENCY_WITH_DISPLAY_VALUE") {
        var invalidValue = (0, _ramda.isNil)(displayValueFromData) || displayValueFromData === defaultValue || isNaN(+displayValueFromData);
        return invalidValue ? defaultValue : _formatted_number2.default.prototype.numberFormatter(_currency_utility2.default.convertToCurrencyWithScaleSuffixAnd2DecimalsWithNoRounding(+displayValueFromData, "USD"), this.props.numberFormat);
      }
      if (isCurrencyDataType) {
        return _formatted_number2.default.prototype.numberFormatter(_currency_utility2.default.convertToCurrencyWithScaleSuffixAnd2DecimalsWithNoRounding(valueFromData, "USD"), this.props.numberFormat);
      } else if (dataType === "NA") {
        return displayValueFromData;
      } else if (dataType === "RAW_PERCENTAGE") {
        return (0, _ramda.isNil)(valueFromData) ? defaultValue : _formatted_number2.default.prototype.numberFormatter(valueFromData + "%", this.props.numberFormat);
      } else if (dataIsNotNil(displayValueFromData) && displayValueFromData !== defaultValue) {
        var dataPointSuffix = _constants2.default.getDataPointSuffix()[dataType];
        return _formatted_number2.default.prototype.numberFormatter(displayValueFromData + _string_utility2.default.getLocalizedString(this.props.intl, dataPointSuffix.value, dataPointSuffix.translationKey, {}), this.props.numberFormat);
      }

      if (!(0, _functional_utility.isNilOrEmpty)(this.props.visibleDataPoints) && (0, _ramda.includes)("BREAKDOWN_TABLE_CHILD_CARD_DASH_AS_DEFAULT_VALUE", this.props.visibleDataPoints)) {
        return defaultValue;
      }
      return "";
    }
  }, {
    key: 'renderAsOfDate',
    value: function renderAsOfDate(asOfDate) {
      if ((0, _ramda.isNil)(asOfDate)) {
        return null;
      }
      var formattedAsOfDate = _date_formatter2.default.getLocalFormattedDateForInjectIntl(asOfDate, this.props.intl, false);
      return _react2.default.createElement(
        'span',
        { 'data-testid': 'headerAsOfDate', className: 'font-light disclaimer font-slate-grey' },
        _string_utility2.default.getLocalizedString(this.props.intl, "As of", "pdp-portfolio-as-of-date-label"),
        ' ',
        formattedAsOfDate
      );
    }
  }, {
    key: 'shouldDisplay2Columns',
    value: function shouldDisplay2Columns() {
      return !(0, _ramda.isNil)(this.props.subColumnHeader) && this.props.subColumnHeader.length >= 3 && this.props.subColumnHeader[1] !== "";
    }
  }, {
    key: 'populateTD',
    value: function populateTD(data, i) {
      var subColumnAlignment = this.props.subColumnAlignment;

      var leftTextStyle = this.getLeftTextStyle(data);
      var rightTextStyle = this.getRightTextStyle(data);
      var nameLabel = _string_utility2.default.renderFormattedLabel(data.name, data.translationKey);
      var valStyle = !(0, _ramda.isNil)(subColumnAlignment) && subColumnAlignment[1] === 'left' ? leftTextStyle : rightTextStyle;
      var value = _react2.default.createElement(
        'td',
        { key: i + '-1', className: '' + valStyle,
          'data-testid': this.props.componentId + "-child-value" },
        this.renderValue(data)
      );
      var secValStyle = !(0, _ramda.isNil)(subColumnAlignment) && subColumnAlignment[2] === 'left' ? leftTextStyle : rightTextStyle;
      var secondaryValue = _react2.default.createElement(
        'td',
        { key: i + '-2', className: secValStyle,
          'data-testid': this.props.componentId + "-child-secondary-value" },
        (0, _ramda.compose)(_string_utility2.default.mapToDashIfEmptyString, this.renderValue)(data, "displaySecondaryValue", "secondaryValue")
      );
      var output = [];

      output.push(_react2.default.createElement(
        'td',
        { className: leftTextStyle },
        _react2.default.createElement(
          'span',
          null,
          nameLabel
        ),
        '\xA0',
        this.computeDisclosureAndRenderIcon(data.name, data.disclosureId, nameLabel)
      ));

      if (!(0, _ramda.isNil)(data.displayValue) || !(0, _functional_utility.isNilOrEmpty)(this.props.visibleDataPoints) && (0, _ramda.includes)("BREAKDOWN_TABLE_CHILD_CARD_DASH_AS_DEFAULT_VALUE", this.props.visibleDataPoints)) {
        output.push(value);
      } else {
        output.push(_react2.default.createElement('td', null));
      }

      if (!(0, _ramda.isNil)(data.displaySecondaryValue) || this.shouldDisplay2Columns() && (0, _ramda.includes)("PORTFOLIO_CHILD_CARD_SHOW_SECONDARY_VALUE", this.props.visibleDataPoints || []) && this.props.showDashOn2ndColumn) {
        output.push(secondaryValue);
      } else {
        output.push(_react2.default.createElement('td', null));
      }

      return output;
    }
  }, {
    key: 'generateTableRow',
    value: function generateTableRow(data, i) {
      var _this2 = this;

      var displaySecondaryValue = data.displaySecondaryValue,
          displayTertiaryValue = data.displayTertiaryValue,
          displayQuarternaryValue = data.displayQuarternaryValue,
          group = data.group;

      var tableData = [];
      var thirdFourthRow = [];
      var leftTextStyle = this.getLeftTextStyle(data);
      var rightTextStyle = this.getRightTextStyle(data);

      if (data.name === 'Total') {
        data.translationKey = 'pdp-portfolio-total-label';
      }

      var greaterThanOneColumnData = function greaterThanOneColumnData() {
        var extraTableData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        return (0, _ramda.concat)([_this2.populateTD(data, i)], extraTableData);
      };

      if ((0, _ramda.and)(dataIsNotNil(displayTertiaryValue), !dataIsNotNil(displayQuarternaryValue))) {
        return greaterThanOneColumnData([_react2.default.createElement(
          'td',
          { key: i + '-3', className: rightTextStyle, 'data-testid': this.props.componentId + "-child-tertiary-value" },
          (0, _ramda.compose)(_string_utility2.default.mapToDashIfEmptyString, this.renderValue)(data, "displayTertiaryValue", "tertiaryValue")
        )]);
      }
      if ((0, _ramda.and)(dataIsNotNil(displayTertiaryValue), dataIsNotNil(displayQuarternaryValue))) {
        thirdFourthRow.push(_react2.default.createElement(
          'td',
          { key: i + '-3', className: rightTextStyle,
            'data-testid': this.props.componentId + "-child-tertiary-value" },
          (0, _ramda.compose)(_string_utility2.default.mapToDashIfEmptyString, this.renderValue)(data, "displayTertiaryValue", "tertiaryValue")
        ));
        thirdFourthRow.push(_react2.default.createElement(
          'td',
          { key: i + '-4', className: rightTextStyle,
            'data-testid': this.props.componentId + "-child-quarternary-value" },
          (0, _ramda.compose)(_string_utility2.default.mapToDashIfEmptyString, this.renderValue)(data, "displayQuarternaryValue", "quarternaryValue")
        ));

        return greaterThanOneColumnData([thirdFourthRow]);
      } else if (dataIsNotNil(displaySecondaryValue) || this.shouldDisplay2Columns() && this.props.showDashOn2ndColumn) {
        return greaterThanOneColumnData();
      } else if (dataIsNotNil(group)) {
        if (data.group === "HEADER") {
          tableData.push(_react2.default.createElement(
            'td',
            { key: i + '-3', colSpan: 2, className: 'text-left tag',
              'data-testid': this.props.componentId + "-groupheader-col" },
            _react2.default.createElement('span', {
              dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(_string_utility2.default.getLocalizedString(this.props.intl, data.name, data.translationKey)) } }),
            '\xA0',
            this.computeDisclosureAndRenderIcon(data.name, data.disclosureId, _string_utility2.default.getLocalizedString(this.props.intl, data.name, data.translationKey)),
            _react2.default.createElement('br', null),
            ' ',
            this.renderAsOfDate(data.asOfDate)
          ));
          tableData.push(_react2.default.createElement('td', { key: i + '-4', className: "text-right tag",
            'data-testid': this.props.componentId + "-groupheader-col",
            dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.renderHeaderValue(data)) } }));
          tableData.push(_react2.default.createElement(
            'td',
            { className: "width-percent-40" },
            '\xA0'
          ));
          return tableData;
        } else {
          tableData.push(_react2.default.createElement('td', { key: i + '-5', 'data-testid': this.props.componentId + '-child-padding', width: "30px" }));
          tableData.push(_react2.default.createElement('td', { key: i + '-6', colSpan: 2, className: '' + leftTextStyle,
            'data-testid': this.props.componentId + "-groupchild-col", dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(_string_utility2.default.getLocalizedString(this.props.intl, data.name, data.translationKey)) } }));
          tableData.push(_react2.default.createElement('td', { key: i + '-7', className: '' + rightTextStyle,
            'data-testid': this.props.componentId + "-groupchild-col",
            dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.renderValue(data)) } }));
          tableData.push(_react2.default.createElement(
            'td',
            { className: "width-percent-40" },
            '\xA0'
          ));
          return tableData;
        }
      }

      if (data.name === 'Total of top 10') {
        tableData.push(_react2.default.createElement(
          'td',
          { key: i + '-8', colSpan: 3, className: 'text-left font-bold',
            'data-testid': this.props.componentId + "-child-name" },
          _react2.default.createElement('span', {
            dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(data.name) } }),
          '\xA0',
          this.computeDisclosureAndRenderIcon(data.name, data.disclosureId),
          _react2.default.createElement('br', null),
          ' ',
          this.renderAsOfDate(data.asOfDate)
        ));
        tableData.push(_react2.default.createElement('td', { key: i + '-9', className: 'text-right font-bold',
          'data-testid': this.props.componentId + "-child-value",
          dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.renderValue(data)) } }));
        tableData.push(_react2.default.createElement(
          'td',
          { className: "width-percent-40" },
          '\xA0'
        ));
      } else {
        tableData.push(_react2.default.createElement(
          'td',
          { key: i + '-10', colSpan: 3, className: '' + leftTextStyle,
            'data-testid': this.props.componentId + "-child-name" },
          _react2.default.createElement('span', {
            dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(_string_utility2.default.getLocalizedString(this.props.intl, data.name, data.translationKey)) } }),
          '\xA0',
          this.computeDisclosureAndRenderIcon(data.name, data.disclosureId, _string_utility2.default.getLocalizedString(this.props.intl, data.name, data.translationKey)),
          _react2.default.createElement('br', null),
          ' ',
          this.renderAsOfDate(data.asOfDate)
        ));
        tableData.push(_react2.default.createElement('td', { key: i + '-11', className: '' + rightTextStyle,
          'data-testid': this.props.componentId + "-child-value",
          dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.renderValue(data)) } }));
        tableData.push(_react2.default.createElement(
          'td',
          { className: "width-percent-40" },
          '\xA0'
        ));
      }

      return tableData;
    }
  }, {
    key: 'getRightTextStyle',
    value: function getRightTextStyle(data) {
      return data.style === "bold" ? "text-right font-bold" : "text-right";
    }
  }, {
    key: 'getLeftTextStyle',
    value: function getLeftTextStyle(data) {
      return data.style === "bold" ? "text-left font-bold" : "text-left";
    }
  }, {
    key: 'generateDisclosure',
    value: function generateDisclosure(data) {
      var displaySecondaryValue = data.displaySecondaryValue,
          displayTertiaryValue = data.displayTertiaryValue,
          displayQuarternaryValue = data.displayQuarternaryValue,
          group = data.group;

      var disclosures = [];

      if ((0, _ramda.and)(dataIsNotNil(displayTertiaryValue), dataIsNotNil(displayQuarternaryValue)) || dataIsNotNil(displaySecondaryValue)) {
        return null;
      } else if (dataIsNotNil(group) && data.group === "HEADER") {
        disclosures.push(this.renderSingleDisclosure(data));
        return disclosures;
      }
      disclosures.push(this.renderSingleDisclosure(data));
      return disclosures;
    }
  }, {
    key: 'renderSingleDisclosure',
    value: function renderSingleDisclosure(data) {
      return _react2.default.createElement('div', {
        key: data.disclosureId,
        className: 'margin-bottom-15 text-justified print-page-break font-slate-grey',
        dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.computeDisclosure(data.name, data.disclosureId)) } });
    }
  }, {
    key: 'generateTableRows',
    value: function generateTableRows() {
      var _this3 = this;

      var tableRows = this.props.id === 'propertyBreakdownCard' ? this.generateTableRowsForPropertyBreakdown() : this.generateTableRowsForTabularData();
      if (!(0, _ramda.isNil)(this.props.breakdown.data)) {
        mapIndexed(function (data, i) {
          var tableData = _this3.generateTableRow(data, i);
          var tableRow = _react2.default.createElement(
            'tr',
            { 'data-testid': _this3.props.componentId + "-row",
              name: _this3.props.componentId + "-row",
              className: 'portfolio-override-bold category row-divider',
              key: i + '-' },
            tableData
          );
          tableRows.push(tableRow);
        }, this.props.breakdown.data);
      }
      return tableRows;
    }
  }, {
    key: 'generateTableRowsForTabularData',
    value: function generateTableRowsForTabularData() {
      var _this4 = this;

      var tableRows = [];
      if (!(0, _ramda.isNil)(this.props.breakdown.tabularDataMap)) {
        var i = 1;
        _collection_utility.CollectionUtility.forEachIndexed(this.props.breakdown.tabularDataMap, function (value, key) {
          var tableData = _this4.generateTableRowForTabular(value, key);
          var tableRow = _react2.default.createElement(
            'tr',
            { 'data-testid': _this4.props.componentId + "-row",
              name: _this4.props.componentId + "-row",
              className: 'portfolio-override-bold category row-divider',
              key: i + '-' },
            tableData
          );
          tableRows.push(tableRow);
          i++;
        });
      }
      return tableRows;
    }
  }, {
    key: 'generateTableRowForTabular',
    value: function generateTableRowForTabular(breakdownRow, key) {
      var _this5 = this;

      var tableData = [];
      var leftTextStyle = "text-left";
      var _props = this.props,
          subColumnHeader = _props.subColumnHeader,
          subColumnAlignment = _props.subColumnAlignment;

      var formatByDataType = !(0, _functional_utility.isNilOrEmpty)(this.props.visibleDataPoints) && (0, _ramda.includes)("BREAKDOWN_CELL_FORMAT_BY_DATATYPE", this.props.visibleDataPoints);

      var numberOfColumns = subColumnHeader.length;
      mapIndexed(function (cell, i) {
        var isPercentageDataType = cell.dataType === "PERCENTAGE";
        tableData.push(_react2.default.createElement(
          'td',
          { colSpan: numberOfColumns === 2 && i % 2 === 0 ? 3 : 1,
            key: i + '-11',
            className: i === 0 ? '' + leftTextStyle : _this5.getCellAlignmentByDataType(formatByDataType, isPercentageDataType, (0, _ramda.isNil)(subColumnAlignment) ? null : subColumnAlignment[i]),
            'data-testid': _this5.props.componentId + "-child-value"
          },
          (0, _ramda.isNil)(cell.displayValue) ? "-" : _this5.getCellDisplayValueByDataType(formatByDataType, isPercentageDataType, cell.displayValue)
        ));
      }, breakdownRow.cellList);

      if (key.startsWith("Net Liquidity")) {
        for (var i = 0; i < numberOfColumns - 2; i++) {
          tableData.splice(1, 0, _react2.default.createElement('td', null));
        }
      }
      return tableData;
    }
  }, {
    key: 'generateTableRowsForPropertyBreakdown',
    value: function generateTableRowsForPropertyBreakdown() {
      var _this6 = this;

      var tableRows = [];
      if (!(0, _ramda.isNil)(this.props.breakdown.tabularDataMap)) {
        var i = 1;
        _collection_utility.CollectionUtility.forEachIndexed(this.props.breakdown.tabularDataMap, function (value, key) {
          var tableData = _this6.generateTableRowForPropertyBreakdown(value, key);
          var tableRow = _react2.default.createElement(
            'tr',
            { 'data-testid': _this6.props.componentId + "-row",
              name: _this6.props.componentId + "-row",
              className: 'portfolio-override-bold category row-divider',
              key: i + '-' },
            tableData
          );
          tableRows.push(tableRow);
          i++;
        });
      }
      return tableRows;
    }
  }, {
    key: 'generateTableRowForPropertyBreakdown',
    value: function generateTableRowForPropertyBreakdown(breakdownRow, key) {
      var _this7 = this;

      var tableData = [];

      tableData.push(_react2.default.createElement(
        'td',
        { key: '0', className: 'text-left category',
          'data-testid': this.props.componentId + "-child-value" },
        key
      ));

      mapIndexed(function (cell, i) {
        tableData.push(_react2.default.createElement(
          'td',
          { key: '' + i,
            className: 'text-right category',
            'data-testid': _this7.props.componentId + "-child-value" },
          (0, _ramda.isNil)(cell.displayValue) ? "-" : cell.displayValue
        ));
      }, breakdownRow.cellList);

      return tableData;
    }
  }, {
    key: 'renderCellValue',
    value: function renderCellValue(breakdownRow, i) {
      return (0, _ramda.isNil)(breakdownRow.cellList[i].displayValue) ? "-" : breakdownRow.cellList[i].displayValue;
    }
  }, {
    key: 'getCellAlignmentByDataType',
    value: function getCellAlignmentByDataType(formatByDataType, isPercentageDataType, columnAlignmentOverride) {
      var rightTextStyle = "text-right category";
      var leftTextStyle = "text-left category";
      if (!(0, _ramda.isNil)(columnAlignmentOverride)) {
        return columnAlignmentOverride === 'left' ? leftTextStyle : rightTextStyle;
      }

      if (formatByDataType) {
        return isPercentageDataType ? rightTextStyle : leftTextStyle;
      }
      return rightTextStyle;
    }
  }, {
    key: 'getCellDisplayValueByDataType',
    value: function getCellDisplayValueByDataType(formatByDataType, isPercentageDataType, value) {
      if (formatByDataType) {
        return isPercentageDataType ? _formatted_number2.default.prototype.numberFormatter(value, this.props.numberFormat) : value;
      }
      return value;
    }
  }, {
    key: 'generateDisclosures',
    value: function generateDisclosures() {
      var _this8 = this;

      var disclosures = [];
      {
        _collection_utility.CollectionUtility.map(this.props.breakdown.data, function (data) {
          var disclosure = _this8.generateDisclosure(data);
          disclosures.push(disclosure);
        });
      }
      return disclosures;
    }
  }, {
    key: 'generateTableHeaders',
    value: function generateTableHeaders() {
      var _props2 = this.props,
          subColumnHeader = _props2.subColumnHeader,
          subColumnAlignment = _props2.subColumnAlignment,
          subColumnHeaderDisclosure = _props2.subColumnHeaderDisclosure;

      var markup = [];

      if (dataIsNotNil(subColumnHeader)) {
        for (var i = 0; i < subColumnHeader.length; i++) {
          markup.push(_react2.default.createElement(
            'td',
            {
              colSpan: this.getHeaderColSpan(subColumnHeader, i),
              key: i,
              'data-testid': this.props.componentId + "-child-subheading",
              className: 'border-top-none margin-top-0 padding-top-0 tag ' + (i === 0 ? "" : this.getTabularHeaderAlignmentByDataType(i, !(0, _ramda.isNil)(subColumnAlignment) ? subColumnAlignment[i] : null))
            },
            subColumnHeader[i],
            subColumnHeaderDisclosure != null && subColumnHeaderDisclosure[i] != null && this.computeDisclosureAndRenderIcon(this.props.id + subColumnHeader[i], subColumnHeaderDisclosure[i], subColumnHeader[i])
          ));
        }
        return markup;
      }
    }
  }, {
    key: 'getTabularHeaderAlignmentByDataType',
    value: function getTabularHeaderAlignmentByDataType(index, alignment) {
      var headerAlignment = (0, _ramda.isNil)(alignment) ? "text-right" : 'text-' + alignment;
      if (!(0, _ramda.isNil)(this.props.breakdown.tabularDataMap) && !(0, _functional_utility.isNilOrEmpty)(this.props.visibleDataPoints) && (0, _ramda.includes)("BREAKDOWN_CELL_FORMAT_BY_DATATYPE", this.props.visibleDataPoints)) {
        _collection_utility.CollectionUtility.map(this.props.breakdown.tabularDataMap, function (data) {
          if (data.cellList[index].dataType !== "PERCENTAGE" && (0, _ramda.isNil)(alignment)) {
            headerAlignment = "";
          }
        });
      }
      return headerAlignment;
    }
  }, {
    key: 'computeDisclosureAndRenderIcon',
    value: function computeDisclosureAndRenderIcon(tooltipId, disclosureId, nameLabel) {
      var disclosure = this.computeDisclosure(tooltipId, disclosureId);
      return (0, _ramda.isNil)(disclosure) ? null : this.renderDisclosureIcon(tooltipId, disclosure, nameLabel);
    }
  }, {
    key: 'renderDisclosureIcon',
    value: function renderDisclosureIcon(tooltipId, disclosure, nameLabel) {
      var _this9 = this;

      var formattedId = tooltipId.replace(/\%/g, "").replace(/\./g, "").replace(/\)/g, "").replace(/\(/g, "").trim().replace(/[\/\ ]/gi, "_").toLowerCase();
      return _react2.default.createElement(
        'span',
        { 'data-testid': formattedId, tabIndex: 0, id: 'disclosure-' + formattedId, className: 'icon-info print-hide',
          role: 'button',
          'aria-label': 'more information about ' + nameLabel,
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleEnterClick(_this9, event, _this9.handleDisclosureIconClick.bind(_this9, event, formattedId, disclosure));
          },
          onClick: function onClick(event) {
            return _this9.handleDisclosureIconClick(event, formattedId, disclosure);
          }
        },
        ' '
      );
    }
  }, {
    key: 'handleDisclosureIconClick',
    value: function handleDisclosureIconClick(event, formattedId, disclosure) {
      var el = this.getIconEl(formattedId);
      var elHeight = el.offsetHeight;
      var elWidth = el.parentNode.getBoundingClientRect().left;
      var elRect = el.getBoundingClientRect();
      var arrowHeight = 4;
      var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
      var datapointWidth = el.parentNode.children[0].getBoundingClientRect().width;
      var elToolTipWidth = void 0,
          elToolTipContentWidth = void 0;
      if (datapointWidth > 300) {
        elToolTipWidth = datapointWidth + 50;
        elToolTipContentWidth = datapointWidth + 50;
      }

      var elOffset = {
        top: elRect.top + docTop + arrowHeight + elHeight,
        left: elWidth + 8,
        arrowPosition: elRect.left - elWidth - 11,
        toolTipWidth: elToolTipWidth,
        toolTipContentWidth: elToolTipContentWidth
      };

      this.props.tooltip.openTooltip(elOffset, disclosure, null, true, event);
    }
  }, {
    key: 'computeDisclosure',
    value: function computeDisclosure(tooltipId, disclosureId) {
      if (!(0, _ramda.isNil)(tooltipId)) {
        tooltipId = tooltipId.replace(/\./g, "").replace(/\)/g, "").replace(/\(/g, "").replace(/[\/\ ]/gi, "_").toLowerCase();
      }
      var portfolioStatsDisclosures = {
        "p_e_ratio_1_yr_forecast": "pdpDataPointPERatio1YrForecast",
        "p_e_ratio_1_yr_trailing": "pdpDataPointPERatio1YrTrailing",
        "average_life": "pdpDataPointAverageLife",
        "effective_duration": "pdpDataPointDuration",
        "duration": "pdpDataPointDuration",
        "occupancy": "pdpDataPointOccupancyPercentage",
        "total_net_asset_value": "pdpDataPointTotalNAVatJPMOwnership",
        "total_asset_value": "pdpDataPointTotalAssetValue",
        "leverage_ratio": "pdpDataPointLeverageRatio"
      };

      var defaultToLegacyDisclosureId = (0, _ramda.defaultTo)(portfolioStatsDisclosures[tooltipId]);

      return this.disclosures[defaultToLegacyDisclosureId(disclosureId)];
    }
  }, {
    key: 'getIconEl',
    value: function getIconEl(tooltipId) {
      return document.getElementById('disclosure-' + tooltipId);
    }
  }, {
    key: 'render',
    value: function render() {
      if ((0, _ramda.isNil)(this.props.breakdown) || (0, _functional_utility.isNilOrEmpty)(this.props.breakdown.data) && (0, _functional_utility.isNilOrEmpty)(this.props.breakdown.tabularDataMap)) {
        return null;
      }

      var controller = !(0, _ramda.isNil)(this.props.visibleDataPoints) && (0, _ramda.includes)("DOWNLOAD_HOLDINGS_AS_PDF", this.props.visibleDataPoints) ? "pdf" : "excel";
      var controllerType = this.props.controllerType || controller;
      var excelServiceURL = encodeURI(this.props.gaiaRedirectUrl + '/' + controllerType + '?type=' + this.props.excelDownloadType + '&cusip=' + this.props.cusip + '&country=' + this.props.country + '&role=' + this.props.role + '&locale=' + _string_utility2.default.generateLocale());

      var ariaLabel = "";
      if (!(0, _ramda.isNil)(this.props.header)) {
        var title = (0, _functional_utility.isNilOrEmpty)(this.props.header.key) ? this.props.header : _string_utility2.default.getLocalizedString(this.props.intl, this.props.header.props.defaultMessage, this.props.header.key);
        ariaLabel = 'Read more about ' + title;
      }

      return _react2.default.createElement(
        'div',
        { className: this.props.componentId + "-child-card", 'aria-labelledby': this.props.id },
        this.props.activeCardHandler ? _react2.default.createElement(_reactWaypoint2.default, { topOffset: '35%', bottomOffset: '80%',
          onEnter: this.props.activeCardHandler.bind(this, this.props.id) }) : null,
        _react2.default.createElement(
          _card_component2.default,
          _extends({
            dataTest: this.props.id
          }, this.getBreakdownChildCardHeaderProps),
          !this.props.hideTable && _react2.default.createElement(_table_component2.default, {
            tableHeaders: this.generateTableHeaders(),
            tableRows: this.generateTableRows(),
            activeTab: this.props.activeTab,
            breakpoint: this.props.breakpoint
          }),
          !(0, _ramda.isNil)(this.props.excelDownloadType) ? _react2.default.createElement(_button2.default, {
            role: this.props.role,
            dataTest: this.props.id + '-download-link',
            downloadURL: excelServiceURL,
            dataTestLink: this.props.id + '-excel-download',
            text: this.props.downloadBtnLabel || _string_utility2.default.getLocalizedString(this.props.intl, 'Download data', 'pdp-download-data-button-label'),
            additionalClassName: "mobile-full-width margin-top-20"
          }) : null,
          _react2.default.createElement(_disclosure2.default, { disclosureText: this.props.disclosureText, placementId: this.props.placementId, shouldAlwaysShowMore: this.props.shouldAlwaysShowMore, arialabel: ariaLabel }),
          !(0, _functional_utility.isNilOrEmpty)(this.props.secondDisclosureText) && !(0, _functional_utility.isNilOrEmpty)(this.props.secondPlacementId) && _react2.default.createElement(_disclosure2.default, {
            disclosureText: this.props.secondDisclosureText,
            placementId: this.props.secondPlacementId,
            shouldAlwaysShowMore: this.props.shouldAlwaysShowMore,
            arialabel: ariaLabel }),
          _react2.default.createElement(
            'div',
            { 'data-testid': this.props.componentId + "-print-disclosures", className: 'text-justified font-light caption print-display display-none' },
            this.generateDisclosures()
          )
        )
      );
    }
  }, {
    key: 'disclosures',
    get: function get() {
      return (0, _ramda.defaultTo)([], this.props.disclosures);
    }
  }, {
    key: 'getBreakdownChildCardHeaderProps',
    get: function get() {
      if ((0, _ramda.isNil)(this.props.header)) {
        return {
          breakpoint: this.props.breakpoint,
          hideCardBorder: true,
          hideHeader: true
        };
      } else {
        return {
          headerTitle: this.props.header,
          headerTitleId: this.props.id,
          headerTitleLabel: this.props.componentId + "-child-header",
          breakpoint: this.props.breakpoint,
          headerLabel: this.props.hideEffectiveDate ? null : _date_formatter2.default.getEffectiveDateHeader(this.props.id, this.props.breakdown.effectiveDate, this.props.country, this.props.role, this.props.breakpoint, undefined, this.props.asOfDateKey)
        };
      }
    }
  }]);

  return BreakdownTableChildCard;
}(_react2.default.Component);

exports.default = (0, _reactIntl.injectIntl)(BreakdownTableChildCard, { withRef: true });